import TablePage from '@/found/components/table_page';
import { ProcessLog } from '@/found/modules';
import Form from './form';

export default {
  extends: TablePage,
  data() {
    return {
      params: {},
    };
  },
  components: {
    Form,
    ProcessLog,
  },
  created() {
    this.getConfigList('main_list');
  },
  methods: {
    // 控制按钮显示
    clickVisible({ row, val: { code } }) {
      const { approveType, processCode } = row;
      if (code === 'edit' && (approveType !== '0' && approveType !== '3')) {
        return false;
      }
      if (code === 'process_log' && !processCode) {
        return false;
      }
      return true;
    },
    modalClick({ val, row }) {
      const { code } = val;
      if (code === 'add' || code === 'edit' || code === 'view') {
        this.formConfig = {
          ...this.formConfig,
          code,
          row,
        };
        this.modalConfig.title = val.name || '查看';
        this.openFull();
      } else if (code === 'process_log') {
        this.formConfig = {
          ...this.formConfig,
          code,
          row: { processNo: row.processCode },
        };

        this.modalConfig.title = '流程日志';
        this.formName = 'ProcessLog';
        this.openDrawer();
      }
    },
  },
};
